import { subscribeUserObjectEvents } from '@/lib/realtime/chat-realtime-service';

const REFRESH_DEBOUNCE_MS = 150;

const userChangeListeners = new Set();
const userRefreshListeners = new Set();

let isInstalled = false;
let refreshVersion = 0;
let refreshTimer = null;
let pendingRefreshChange = null;

function notifyUserChange(change) {
  for (const listener of userChangeListeners) {
    try {
      listener(change);
    } catch (_error) {
      // ignore listener errors
    }
  }
}

function notifyUserRefresh(change) {
  refreshVersion += 1;
  for (const listener of userRefreshListeners) {
    try {
      listener({
        version: refreshVersion,
        change,
      });
    } catch (_error) {
      // ignore listener errors
    }
  }
}

function queueRefresh(change) {
  pendingRefreshChange = change;
  if (refreshTimer !== null) {
    return;
  }
  refreshTimer = setTimeout(() => {
    const nextChange = pendingRefreshChange;
    pendingRefreshChange = null;
    refreshTimer = null;
    notifyUserRefresh(nextChange);
  }, REFRESH_DEBOUNCE_MS);
}

function handleRawUserObjectEvent(rawEvent) {
  if (!rawEvent || typeof rawEvent !== 'object') {
    return;
  }
  notifyUserChange(rawEvent);
  queueRefresh(rawEvent);
}

function installUserRealtimeBridge() {
  if (isInstalled) {
    return;
  }
  isInstalled = true;
  subscribeUserObjectEvents(handleRawUserObjectEvent);
}

export function getUserRefreshVersion() {
  installUserRealtimeBridge();
  return refreshVersion;
}

export function subscribeUserChanges(listener) {
  installUserRealtimeBridge();
  if (typeof listener !== 'function') {
    return () => {};
  }
  userChangeListeners.add(listener);
  return () => {
    userChangeListeners.delete(listener);
  };
}

export function subscribeUserRefresh(listener) {
  installUserRealtimeBridge();
  if (typeof listener !== 'function') {
    return () => {};
  }
  userRefreshListeners.add(listener);
  return () => {
    userRefreshListeners.delete(listener);
  };
}
